import { ProfileContents } from '../store/profile/profile.interface'

export function getName(profileContents: ProfileContents) {
  if (profileContents.userTypeId === 1) {
    return `${profileContents.lastName} ${profileContents.firstName}`
  } else {
    return profileContents.name
  }
}
